const API_BASE_URL = 'https://admin.xoxolite.com/xoxo/api';

export default { API_BASE_URL };